<div class="glai-container">
  <div class="row bg-secondary">
    <div class="col-12">
      <h2><i class="bi bi-stars"></i> Smart Assistant</h2>
    </div>
  </div>
  <div class="row bg-neutral">
    <div class="col-12">
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('lesson_planning')"
        (click)="toggleMode('lesson_planning')">
        Lesson & Activity Planning
      </button>
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('diff_and_mods')"
        (click)="toggleMode('diff_and_mods')">
        Differentiation and Modifications
      </button>
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('assessments_and_feedback')"
        (click)="toggleMode('assessments_and_feedback')">
        Assessments and Feedback
      </button>
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('communication')"
        (click)="toggleMode('communication')">
        Professional Communication
      </button>
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('default')"
        (click)="toggleMode('default')">
        Question & Answer
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="messages-container" #messagesContainer>
        <div
          *ngFor="let message of messages"
          class="message"
          [class.user-message]="message.role === 'user'"
          [class.ai-message]="message.role === 'assistant'">
          <div *ngIf="message.thinking" class="thinking-content">
            {{ message.thinking }}
          </div>
          <div class="message-content">
            <markdown>{{ message.content }}</markdown>
          </div>
          <div *ngFor="let file of message.files">
            <span class="file-attachment">{{ file.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="input-container">
        <div class="text-input">
          <div class="input-file">
            <app-file-upload
              #uploadComponent
              [uploadType]="uploadType"
              [style]="uploadStyle"
              (outputFiles)="addToFileList($event); fileUploads.emit($event)" />
          </div>
          <input
            type="text"
            class="input-msg"
            [(ngModel)]="userMessage"
            (keyup.enter)="sendMessage()"
            [disabled]="isLoading"
            placeholder="Ask me anything..." />
          <button
            class="btn btn-primary input-btn"
            (click)="sendMessage()"
            [disabled]="isLoading || !userMessage.trim()">
            <i *ngIf="!isLoading" class="bi bi-send"></i>
            <i *ngIf="isLoading" class="bi bi-hourglass-split"></i>
          </button>
        </div>
        <div>
          <app-file-list
            (deletedFile)="removeFromFileList($event)"
            [fileList]="uploadedFiles"></app-file-list>
        </div>
      </div>
    </div>
  </div>
</div>
